import { BASE_URL, AUTH_HEADERS } from "./config";

export const getCustomFields = async (statusId, checklistId) => {
    try {
        const response = await fetch(`${BASE_URL}/statuses/${statusId}/checklists/${checklistId}/custom_fields`, {
            headers: AUTH_HEADERS
        });
        
        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            return [];
        }
    } catch (error) {
        return [];
    }
};

export const getCustomField = async (statusId, checklistId, cfId) => {
    if (cfId === undefined || cfId === null) {
        return {};
    }
    const url = `${BASE_URL}/statuses/${statusId}/checklists/${checklistId}/custom_fields/${cfId}`;
    const response = await fetch(url, {
        headers: AUTH_HEADERS
    });
    if (response.ok) {
        return await response.json();
    }
    return {};
};


export const createCustomField = async (statusId, checklistId, customField) => {
    const url = `${BASE_URL}/statuses/${statusId}/checklists/${checklistId}/custom_fields`;
    const response = await fetch(url, {
        method: "POST",
        headers: AUTH_HEADERS,
        body: JSON.stringify(customField)
    });
    if (response.ok) {
        return await response.json();
    }
    return {};
};

export const updateCustomField = async (statusId, checklistId, cfId, customField) => {
    if (cfId === undefined || cfId === null) {
        return {};
    }
    const url = `${BASE_URL}/statuses/${statusId}/checklists/${checklistId}/custom_fields/${cfId}`;
    const response = await fetch(url, {
        method: "PATCH",
        headers: AUTH_HEADERS,
        body: JSON.stringify(customField)
    });
    if (response.ok) {
        return await response.json();
    }
    return {};
};

export const deleteCustomField = async (statusId, checklistId, cfId) => {
    if (cfId === undefined || cfId === null) {
        return false;
    }
    const url = `${BASE_URL}/statuses/${statusId}/checklists/${checklistId}/custom_fields/${cfId}`;
    const response = await fetch(url, {
        method: "DELETE",
        headers: AUTH_HEADERS
    });
    if (response.ok) {
        return true
    }
    return false
};

export const getCustomFieldOptions = async (statusId, checklistId, cfId) => {
    if (cfId === undefined || cfId === null) {
        return [];
    }
    const url = `${BASE_URL}/statuses/${statusId}/checklists/${checklistId}/custom_fields/${cfId}/options`;
    const response = await fetch(url, {
        headers: AUTH_HEADERS
    });
    if (response.ok) {
        return await response.json();
    }
    return [];
};

export const createCustomFieldOption = async (statusId, checklistId, cfId, option) => {
    if (cfId === undefined || cfId === null) {
        return {};
    }
    const url = `${BASE_URL}/statuses/${statusId}/checklists/${checklistId}/custom_fields/${cfId}/options`;
    const response = await fetch(url, {
        method: "POST",
        headers: AUTH_HEADERS,
        body: JSON.stringify(option)
    });
    if (response.ok) {
        return await response.json();
    }
    return {};
};

export const updateCustomFieldOption = async (statusId, checklistId, cfId, optionId, option) => {
    if (cfId === undefined || cfId === null || optionId === undefined || optionId === null) {
        return {};
    }
    const url = `${BASE_URL}/statuses/${statusId}/checklists/${checklistId}/custom_fields/${cfId}/options/${optionId}`;
    const response = await fetch(url, {
        method: "PATCH",
        headers: AUTH_HEADERS,
        body: JSON.stringify(option)
    });
    if (response.ok) {
        return await response.json();
    }
    return {};
};

export const deleteCustomFieldOption = async (statusId, checklistId, cfId, optionId) => {
    if (cfId === undefined || cfId === null || optionId === undefined || optionId === null) {
        return false;
    }
    const url = `${BASE_URL}/statuses/${statusId}/checklists/${checklistId}/custom_fields/${cfId}/options/${optionId}`;
    const response = await fetch(url, {
        method: "DELETE",
        headers: AUTH_HEADERS
    });
    if (response.ok) {
        return true;
    }
    return false;
};
